/**
 * Created by yunanw on 17/12/3.
 */
import moment from 'moment'
export default (datetime) => {
  let v = moment(datetime).format('YYYY-MM-DD')
  if (v === 'Invalid date') {
    v = ''
  }
  return v
}



// WEBPACK FOOTER //
// ./src/filters/dateFormat_f.js